import TopStripeModal from './TopStripeModal';

export default TopStripeModal;
